import { observer } from 'mobx-react';
import { useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { orderProductModalStore } from '../../store/orderProductModalStore';
import { productUtils } from '~/utils/productUtils';
import './style.scss';

const ProductDescription: React.FC = observer((): JSX.Element | null => {
  if (!orderProductModalStore.product) {
    return <Skeleton width="100%" count={5} className="mb-1" />;
  }

  const units = useMemo(() => productUtils.getProductCalculatedUnits(orderProductModalStore.product), [orderProductModalStore.product]);
  const text: string = [...units, orderProductModalStore.product.description].filter(Boolean).join(' • ');

  if (text.length) return <p className="product-description-block letter-spacing-5 text-md-size-14 mb-4">{text}</p>;

  return null;
});

export default ProductDescription;
